import { render, staticRenderFns } from "./MainRealtimeDibs.vue?vue&type=template&id=608093c9&scoped=true&"
import script from "./MainRealtimeDibs.vue?vue&type=script&lang=js&"
export * from "./MainRealtimeDibs.vue?vue&type=script&lang=js&"
import style0 from "./MainRealtimeDibs.vue?vue&type=style&index=0&id=608093c9&prod&lang=css&"
import style1 from "./MainRealtimeDibs.vue?vue&type=style&index=1&id=608093c9&prod&scoped=true&lang=css&"
import style2 from "./MainRealtimeDibs.vue?vue&type=style&index=2&id=608093c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608093c9",
  null
  
)

export default component.exports